import { Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "@/site/content";
import { Logo } from "@/site/Logo";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="bg-white border-t border-gray-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo variant="full" />
            <p className="mt-4 text-gray-600 text-sm leading-relaxed max-w-sm">
              {SITE.tagline}. We build affordable, professional websites for
              local owners and contractors — and we show you yours before you
              pay a thing.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-gray-500 mb-3">
              Talk to us
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-gray-800">
                <Mail size={14} className="text-blue-700" />
                <a href={`mailto:${SITE.contact.email}`} data-testid="footer-email">
                  {SITE.contact.email}
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-800">
                <Phone size={14} className="text-blue-700" />
                <a href={`tel:${SITE.contact.phone}`} data-testid="footer-phone">
                  {SITE.contact.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-800">
                <MapPin size={14} className="text-blue-700" />
                {SITE.contact.city}
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-widest text-gray-500 mb-3">
              Jump to
            </div>
            <ul className="space-y-2 text-sm text-gray-800">
              {[
                ["Why it matters", "#problem"],
                ["What's included", "#services"],
                ["How it works", "#process"],
                ["Free demo", "#demo"],
                ["FAQ", "#faq"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="hover:text-blue-700 transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-100 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</div>
          <div>Built for the people who build your town.</div>
        </div>
      </div>
    </footer>
  );
};
